import { inject } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Close from "@material-ui/icons/Close";
import RuleForm from "sections/RuleForm";
import WithAuth from "../containers/WithAuth";

const Wrapper = styled.div`
  && {
    margin-top: 20px;
    padding: 0 50px;
  }
`;

const EmptyIconButton = styled.div`
  && {
    flex: 0 0 48px;
  }
`;

const Bar = styled.div`
  && {
    align-items: center;
    display: flex;
  }
`;

const FormWrapper = styled.div`
  && {
    flex: 0 1 960px;
  }
`;

class NewRule extends React.Component {
  CancelLink = React.forwardRef((props, ref) => (
    <Link ref={ref} to="/rules" {...props} />
  ));

  componentDidMount() {
    const {
      location: { state = {} },
      ruleStore,
      videoSearchStore
    } = this.props;
    ruleStore.clear();
    if (state.fromSaveAsRule) {
      ruleStore.setQuery(videoSearchStore.query);
    }
  }

  render() {
    return (
      <Wrapper>
        <Bar>
          <IconButton component={this.CancelLink}>
            <Close />
          </IconButton>
          <Typography color="textSecondary" variant="h5">
            New Rule
          </Typography>
        </Bar>
        <Bar>
          <EmptyIconButton />
          <FormWrapper>
            <RuleForm />
          </FormWrapper>
        </Bar>
      </Wrapper>
    );
  }
}

export default inject("ruleStore", "videoSearchStore")(WithAuth(NewRule));



// WEBPACK FOOTER //
// ./src/sections/NewRule.js